import { render } from "./toPay.vue?vue&type=template&id=22fc3e58&scoped=true"
import script from "./toPay.vue?vue&type=script&lang=js"
export * from "./toPay.vue?vue&type=script&lang=js"

import "./toPay.vue?vue&type=style&index=0&id=22fc3e58&lang=scss&scoped=true"
import "./toPay.vue?vue&type=style&index=1&id=22fc3e58&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fc3e58"]])

export default __exports__